import { $, $$, isTablet } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-advantages]')) return;

  $$('[data-au-advantages]').forEach(setupAdvantages);
}

function setupAdvantages(module) {
  const items = module.querySelectorAll('[data-au-accordion-side-btn]');
  const itemsContainer = module.querySelector('[data-au-advantages-items]');
  const scrollBarThumb = module.querySelector('[data-au-advantages-scrollbar-thumb]');
  let clickScrolling = false;

  if (itemsContainer) {
    const setOrientation = () =>
      itemsContainer.setAttribute('aria-orientation', isTablet.matches ? 'horizontal' : 'vertical');
    setOrientation();
    isTablet.addEventListener('change', setOrientation);
  }

  items.forEach((item) => {
    item.addEventListener('click', () => {
      datalayerAdvantageItem(module, item);

      if (!isTablet.matches || !itemsContainer) return;

      clickScrolling = true;
      const index = [...items].indexOf(item);
      const itemWidth = items[0]?.offsetWidth + 8;

      if (itemWidth > 0) {
        itemsContainer.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
      }

      setTimeout(() => {
        clickScrolling = false;
      }, 500);
    });
  });

  if (itemsContainer) {
    setupMobileScroll(itemsContainer, scrollBarThumb, items, () => clickScrolling);
  }
}

function setupMobileScroll(itemsContainer, scrollBarThumb, items, isClickScrolling) {
  let scrollTimer;

  function updateScrollBar() {
    if (!isTablet.matches) return;

    const { scrollLeft, scrollWidth, clientWidth } = itemsContainer;
    const scrollableWidth = scrollWidth - clientWidth;
    const atEnd = scrollableWidth <= 0 || scrollLeft >= scrollableWidth - 1;

    itemsContainer.classList.toggle('au-advantages__accordion-items--fade-right', !atEnd);

    if (!scrollBarThumb) return;

    if (scrollableWidth > 0) {
      const progress = scrollLeft / scrollableWidth;
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbLeft = progress * (100 - thumbWidth);

      scrollBarThumb.style.width = `${thumbWidth}%`;
      scrollBarThumb.style.marginLeft = `${thumbLeft}%`;
    }
  }

  itemsContainer.addEventListener('scroll', () => {
    updateScrollBar();

    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      if (!isTablet.matches || isClickScrolling()) return;

      const scrollLeft = itemsContainer.scrollLeft;
      const itemWidth = items[0]?.offsetWidth + 8;

      if (itemWidth > 0) {
        const activeIndex = Math.round(scrollLeft / itemWidth);
        items[activeIndex]?.click();
      }
    }, 150);
  });

  isTablet.addEventListener('change', updateScrollBar);

  updateScrollBar();
}

function datalayerAdvantageItem(module, btn) {
  const moduleTitle = module.querySelector('[data-au-heading-title]')?.textContent?.trim() ?? '';
  const btnLabel = btn.querySelector('[data-au-advantages-item-title]')?.textContent?.trim() ?? '';
  const item_id = `${removeAccentMarkAndUppercase(moduleTitle)}_${removeAccentMarkAndUppercase(btnLabel)}`;

  window.dataLayer?.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

export default { init };
